<script lang="ts">
  import { fade } from 'svelte/transition';
  import CloudIcon from '~icons/mdi/cloud';
  import CloudCheck from '~icons/mdi/cloud-check';
  import Spinner from '~/components/Spinner.svelte';
  import { syncEnabled } from './SyncModal.svelte';
  import { isPremium } from '~/lib/queries.svelte';

  type Props = {
    snapshot: { isPending: boolean; isSuccess: boolean };
  };
  const { snapshot }: Props = $props();

  let showSyncCheck = $state(false);
  const premium = isPremium();
  let prevSyncPending = false;
  let syncCheckTimeout: ReturnType<typeof setTimeout>;

  $effect(() => {
    const isPending = snapshot.isPending;
    if (prevSyncPending && !isPending && snapshot.isSuccess) {
      showSyncCheck = true;
      clearTimeout(syncCheckTimeout);
      syncCheckTimeout = setTimeout(() => (showSyncCheck = false), 1500);
    }
    prevSyncPending = isPending;
  });
</script>

{#if syncEnabled.current && premium.data}
  <div class="sync-container">
    {#if snapshot.isPending}
      <div transition:fade><Spinner /></div>
    {/if}
    <div class="sync-icon">
      {#if showSyncCheck}
        <div class="sync-check" transition:fade><CloudCheck /></div>
      {:else}
        <div transition:fade><CloudIcon /></div>
      {/if}
    </div>
  </div>
{/if}

<style lang="scss">
  @use '~/theme/themify' as *;

  .sync-container {
    position: absolute;
    opacity: 0.6;
    top: 2em;
    right: 0;
    height: 1em;
    overflow: clip;
    display: flex;
    align-items: center;
    :global(.ellipsis) {
      scale: 0.4;
      width: 2.5em;
    }
  }
  .sync-icon {
    position: relative;
    width: 1.5em;
    height: 1.5em;
    * {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .sync-check {
    @include themify {
      color: themed('star-bonus');
    }
  }
</style>
